export const message = {
  reportHourSuccess: "Reporting hours added succesfully.",
  reportHourError: "Please try again.",
};
